import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { ESSENTIALS_HOME_CATEGORY } from '@lyrahealth-inc/shared-app-logic/src/features/essentials/types'

export const QuickLinksIcon: FunctionComponent<QuickLinksBreathingIconProps> = ({ size = 66, category }) => {
  switch (category) {
    case ESSENTIALS_HOME_CATEGORY.MEDITATIONS:
      return (
        <Svg width={size} height={size} viewBox='0 0 125 125' fill='none'>
          <Path
            d='M62.5 113.875C84.3153 113.875 102 104.249 102 92.375C102 80.5009 84.3153 70.875 62.5 70.875C40.6848 70.875 23 80.5009 23 92.375C23 104.249 40.6848 113.875 62.5 113.875Z'
            fill='#B0CAFF'
          />
          <Path
            d='M63.8084 73.7297C79.4718 72.5985 91.5569 64.0716 90.8012 54.6843C90.0456 45.2969 76.7353 38.604 61.072 39.7351C45.4086 40.8662 33.3235 49.3931 34.0792 58.7805C34.8348 68.1678 48.145 74.8608 63.8084 73.7297Z'
            fill='#7587D9'
          />
          <Path
            d='M80.0988 30.9567C81.3355 24.28 74.432 17.5539 64.6795 15.9334C54.9271 14.313 46.0186 18.4118 44.782 25.0885C43.5454 31.7652 50.4489 38.4914 60.2014 40.1118C69.9538 41.7323 78.8622 37.6334 80.0988 30.9567Z'
            fill='#B0CAFF'
          />
        </Svg>
      )
    case ESSENTIALS_HOME_CATEGORY.COURSES:
      return (
        <Svg width={size} height={size} viewBox='0 0 125 125' fill='none'>
          <Path
            d='M83.382 22.8008H26.482C22.9301 22.8008 20.0508 25.6802 20.0508 29.232V71.3258C20.0508 74.8777 22.9301 77.757 26.482 77.757H83.382C86.9339 77.757 89.8133 74.8777 89.8133 71.3258V29.232C89.8133 25.6802 86.9339 22.8008 83.382 22.8008Z'
            fill='#B0CAFF'
          />
          <Path
            d='M47.5566 37.1128V63.4441C47.5566 64.6816 48.9691 65.3941 49.9629 64.6566L67.7316 51.4878C68.5441 50.8878 68.5441 49.6691 67.7316 49.0691L49.9629 35.9003C48.9691 35.1628 47.5566 35.8753 47.5566 37.1128Z'
            fill='#7587D9'
          />
          <Path
            d='M104.95 77.7305H68.3379C66.0941 77.7305 64.2754 75.9117 64.2754 73.668C64.2754 71.4242 66.0941 69.6055 68.3379 69.6055H104.95C107.194 69.6055 109.013 71.4242 109.013 73.668C109.013 75.9117 107.194 77.7305 104.95 77.7305Z'
            fill='#7587D9'
          />
          <Path
            d='M104.95 91.9941H68.3379C66.0941 91.9941 64.2754 90.1754 64.2754 87.9316C64.2754 85.6879 66.0941 83.8691 68.3379 83.8691H104.95C107.194 83.8691 109.013 85.6879 109.013 87.9316C109.013 90.1754 107.194 91.9941 104.95 91.9941Z'
            fill='#7587D9'
          />
          <Path
            d='M104.95 106.262H68.3379C66.0941 106.262 64.2754 104.443 64.2754 102.199C64.2754 99.9555 66.0941 98.1367 68.3379 98.1367H104.95C107.194 98.1367 109.013 99.9555 109.013 102.199C109.013 104.443 107.194 106.262 104.95 106.262Z'
            fill='#7587D9'
          />
        </Svg>
      )
    case ESSENTIALS_HOME_CATEGORY.BREATHING_EXERCISES:
      return (
        <Svg width={size} height={size} viewBox='0 0 125 125' fill='none'>
          <Path
            d='M37.7689 52.862C37.7689 52.862 17.9487 45.2644 12.0859 64.9882C6.223 84.712 25.1518 92.1988 43.6449 85.7284C62.138 79.2581 74.8739 59.9253 84.3944 63.2419C93.915 66.5585 101.844 29.1375 71.9292 27.1175C40.2777 24.9738 37.7755 52.8685 37.7755 52.8685L37.7689 52.862Z'
            fill='#B0CAFF'
          />
          <Path
            d='M48.0863 99C46.9291 99 46.5786 97.43 47.6168 96.9311C52.8475 94.4098 60.9878 89.7997 64.1884 84.2782C69.0687 75.8628 76.7329 52.7323 96.9416 55.1804C113.5 57.1894 120.939 80.1537 109.473 92.6203C105.651 96.7781 100.175 99 94.5411 99H48.0863Z'
            fill='#7587D9'
          />
        </Svg>
      )
    case ESSENTIALS_HOME_CATEGORY.VIRTUAL_EVENTS:
      return (
        <Svg width={size} height={size} viewBox='0 0 125 125' fill='none'>
          <Path
            d='M106.25 27.9191V90.3191C106.25 91.6566 105.206 92.7441 103.912 92.7441H21.0875C19.8 92.7441 18.75 91.6504 18.75 90.3191V27.9191C18.75 26.5816 19.7938 25.4941 21.0875 25.4941H103.912C105.2 25.4941 106.25 26.5816 106.25 27.9191Z'
            fill='#B0CAFF'
          />
          <Path
            d='M82.7869 89.0939H43.1494C43.1369 81.1314 42.8432 70.0064 47.9307 65.3252C49.9619 63.4502 54.5307 60.3877 56.8494 61.3127C65.0682 64.5939 67.8307 62.1939 71.0369 61.4127C74.1744 60.6502 78.7182 64.5002 80.3557 66.9252C83.4182 71.4502 82.9744 81.6564 82.7869 89.0939Z'
            fill='#7587D9'
          />
          <Path
            d='M74.3383 48.1191C74.3383 53.9004 69.907 59.1191 64.4445 59.1191C58.982 59.1191 54.5508 53.9004 54.5508 48.1191C54.5508 42.3379 58.982 37.1191 64.4445 37.1191C69.907 37.1191 74.3383 42.3379 74.3383 48.1191Z'
            fill='#7587D9'
          />
          <Path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M3.73242 92.4941C3.73242 88.9043 6.64257 85.9941 10.2324 85.9941H114.77C118.36 85.9941 121.27 88.9043 121.27 92.4941C121.27 96.084 118.36 98.9941 114.77 98.9941H10.2324C6.64257 98.9941 3.73242 96.084 3.73242 92.4941Z'
            fill='#7587D9'
          />
        </Svg>
      )
    case ESSENTIALS_HOME_CATEGORY.SOUNDSCAPES:
      return (
        <Svg width={size} height={size} viewBox='0 0 125 125' fill='none'>
          <Path
            d='M101.501 29.6377L101.451 85.4485C101.451 93.252 93.7228 99.6304 84.1553 99.6304C74.5877 99.6304 66.8407 93.5534 66.8407 86.0512C66.8407 78.5491 74.594 72.472 84.1553 72.472C87.5328 72.472 90.678 73.2254 93.3399 74.5438V47.2096C84.8144 49.8275 75.9688 51.2777 67.6819 52.0311C66.0246 52.1818 64.386 52.301 62.7789 52.4015C57.3171 52.7405 52.188 52.797 47.6742 52.7342L46.7827 92.3103C46.7827 99.6116 39.0985 107.101 29.5372 107.101C19.9759 107.101 12.2227 101.024 12.2227 93.522C12.2227 86.0198 19.9759 79.9428 29.5372 79.9428C32.965 79.9428 36.1604 80.7213 38.8474 82.071L39.5128 52.4831L39.8707 36.7757C39.8958 33.574 42.1935 30.8682 45.3576 30.3283C45.5271 30.3031 45.6966 30.2843 45.8661 30.278C54.4418 29.9139 62.9735 29.0727 71.2666 27.7731C71.8065 27.6978 72.3527 27.6099 72.8926 27.522C75.9374 27.0198 79.0011 26.4485 82.0521 25.8144C83.5337 25.5131 85.0091 25.1929 86.4781 24.8539C86.6915 24.8037 87.2189 24.6404 87.6835 24.4898C90.8726 23.4916 95.6941 21.9723 99.0026 24.4019C100.616 25.5821 101.501 27.4404 101.501 29.6377Z'
            fill='#B0CAFF'
          />
          <Path
            d='M101.502 29.6377L101.452 85.4485C101.452 93.252 93.7239 99.6304 84.1563 99.6304C74.5888 99.6304 66.8418 93.5534 66.8418 86.0512C66.8418 78.5491 74.5951 72.472 84.1563 72.472C87.5339 72.472 90.6791 73.2254 93.341 74.5438V47.2096C83.1079 50.3549 77.3259 51.441 67.683 52.0311C79.2972 41.2958 81.5636 32.7704 82.0532 25.8144C83.5348 25.5131 85.0101 25.1929 86.4792 24.8539C86.6926 24.8037 87.22 24.6404 87.6845 24.4898C90.8737 23.4916 95.6952 21.9723 99.0037 24.4019C100.617 25.5821 101.502 27.4404 101.502 29.6377Z'
            fill='#7587D9'
          />
        </Svg>
      )
    default:
      return <></>
  }
}

type QuickLinksBreathingIconProps = {
  size?: string | number
  category: ESSENTIALS_HOME_CATEGORY
}
